import type { NotificationActionType } from "@circle-react/types/Notification";

import type { UserImageProps } from "@/react/components/SettingsApp/CompassCompat/UserImage";
import { UserImage } from "@/react/components/SettingsApp/CompassCompat/UserImage";

import { NotificationTypeIcon } from "./NotificationTypeIcon";

export interface UserImageWithIconProps {
  action: NotificationActionType;
  name: string;
  size?: UserImageProps["size"];
  src?: string;
}

export const UserImageWithIcon = ({
  src = "",
  name,
  action,
  size = "8",
}: UserImageWithIconProps) => (
  <div className="relative mr-3 shrink-0">
    <UserImage src={src} name={name} size={size} />
    <NotificationTypeIcon action={action} />
  </div>
);
